import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { VisionMissionPage } from './pages/VisionMissionPage';
import { ServicesPage } from './pages/ServicesPage';
import { AirportsPage } from './pages/AirportsPage';
import { LeadershipPage } from './pages/LeadershipPage';
import { ContactPage } from './pages/ContactPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-64">
      <Routes data-id="element-65">
        <Route path="/" element={<App data-id="element-67">
              <HomePage data-id="element-68" />
            </App>} data-id="element-66" />
        <Route path="/about" element={<App data-id="element-70">
              <AboutPage data-id="element-71" />
            </App>} data-id="element-69" />
        <Route path="/vision-mission" element={<App data-id="element-73">
              <VisionMissionPage data-id="element-74" />
            </App>} data-id="element-72" />
        <Route path="/services" element={<App data-id="element-76">
              <ServicesPage data-id="element-77" />
            </App>} data-id="element-75" />
        <Route path="/airports" element={<App data-id="element-79">
              <AirportsPage data-id="element-80" />
            </App>} data-id="element-78" />
        <Route path="/leadership" element={<App data-id="element-82">
              <LeadershipPage data-id="element-83" />
            </App>} data-id="element-81" />
        <Route path="/contact" element={<App data-id="element-85">
              <ContactPage data-id="element-86" />
            </App>} data-id="element-84" />
      </Routes>
    </BrowserRouter>;
}